/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmEvalsRerunFailedSamples } from "../../funcs/llmEvalsRerunFailedSamples.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.RerunFailedEvalSamplesRequest$inboundSchema,
};

export const tool$llmEvalsRerunFailedSamples: ToolDefinition<typeof args> = {
  name: "llm-evals-rerun-failed-samples",
  description: `Rerun failed eval samples

Queues a completed eval run to retry only samples with sample status 'failed'. Retried samples keep the same run ID and sample IDs, replacing errored sample results in place.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmEvalsRerunFailedSamples(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
